import { render } from "./ReturnClientComponent.vue?vue&type=template&id=39d14c58"
import script from "./ReturnClientComponent.vue?vue&type=script&lang=js"
export * from "./ReturnClientComponent.vue?vue&type=script&lang=js"

import "./ReturnClientComponent.vue?vue&type=style&index=0&id=39d14c58&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__